import React from "react";

interface CyberpunkBackgroundProps {
  mode?: "hero" | "content";
  opacity?: number;
}

/**
 * Subtle industrial blueprint-grid background with a single drifting
 * scanline, rendered in the Industrial Editorial palette.
 *
 * The `mode` and `opacity` props are kept for backwards compatibility with
 * existing pages; they only scale the intensity of the grid layer.
 */
const CyberpunkBackground: React.FC<CyberpunkBackgroundProps> = ({
  mode = "content",
  opacity,
}) => {
  const intensity = Math.min(
    1,
    Math.max(opacity ?? (mode === "hero" ? 1 : 0.8), 0.5)
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      {/* Blueprint grid */}
      <div className="ind-grid-bg" style={{ opacity: intensity }} />
      {/* Drifting scanline (disabled under prefers-reduced-motion) */}
      <div className="ind-scanline" />
    </div>
  );
};

export default CyberpunkBackground;
